class ImageWithTextVideoPopup {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Handle video trigger clicks and touches (for mobile)
    const handleVideoTrigger = (e) => {
      const videoTrigger = e.target.closest("[data-video-trigger]");
      if (videoTrigger) {
        e.preventDefault();
        e.stopPropagation();
        console.log(
          "Video trigger clicked, URL:",
          videoTrigger.dataset.videoUrl
        );
        this.openVideoPopup(videoTrigger.dataset.videoUrl);
      }
    };

    // Add both click and touchstart events for better mobile support
    document.addEventListener("click", handleVideoTrigger);
    document.addEventListener("touchstart", handleVideoTrigger, {
      passive: false,
    });

    // Handle popup close
    document.addEventListener("click", (e) => {
      if (
        e.target.closest("[data-video-popup-close]") ||
        e.target.closest("[data-video-popup]")
      ) {
        this.closeVideoPopup();
      }
    });

    // Handle escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.closeVideoPopup();
      }
    });
  }

  openVideoPopup(videoUrl) {
    const popup = document.querySelector("[data-video-popup]");
    const iframe = popup?.querySelector(".m-video-popup__iframe");
    const loading = popup?.querySelector("[data-video-loading]");

    if (popup && iframe) {
      console.log("Opening video popup for URL:", videoUrl);

      // Show loading
      if (loading) {
        loading.style.display = "block";
      }

      // Convert YouTube URL to embed URL
      const embedUrl = this.convertToEmbedUrl(videoUrl);
      console.log("Converted to embed URL:", embedUrl);

      // Set iframe src
      iframe.src = embedUrl;

      // Show popup with proper styles and centering
      popup.style.display = "flex";
      popup.style.opacity = "1";
      popup.style.visibility = "visible";
      popup.style.alignItems = "center";
      popup.style.justifyContent = "center";
      popup.classList.add("m-open-modal");

      // Prevent body scroll
      document.body.style.overflow = "hidden";

      // Force a reflow to ensure styles are applied
      popup.offsetHeight;

      // Handle iframe load events
      iframe.onload = () => {
        console.log("Iframe loaded successfully");
        if (loading) {
          loading.style.display = "none";
        }
      };

      iframe.onerror = (error) => {
        console.error("Iframe failed to load:", error);
        if (loading) {
          loading.innerHTML = "<p>Video failed to load. Please try again.</p>";
        }
      };

      // Fallback: hide loading after a timeout
      setTimeout(() => {
        if (loading && loading.style.display !== "none") {
          loading.style.display = "none";
        }
      }, 5000);

      console.log("Video popup opened successfully");
    } else {
      console.error("Popup or iframe not found");
    }
  }

  closeVideoPopup() {
    const popup = document.querySelector("[data-video-popup]");
    const iframe = popup?.querySelector(".m-video-popup__iframe");
    const loading = popup?.querySelector("[data-video-loading]");

    if (popup && iframe) {
      console.log("Closing video popup");

      // Hide popup with proper styles
      popup.style.display = "none";
      popup.style.opacity = "0";
      popup.style.visibility = "hidden";
      popup.classList.remove("m-open-modal");

      // Clear iframe src to stop video
      iframe.src = "";

      // Reset loading state
      if (loading) {
        loading.style.display = "block";
        loading.innerHTML = "<p>Loading video...</p>";
      }

      // Restore body scroll
      document.body.style.overflow = "";

      console.log("Video popup closed successfully");
    }
  }

  convertToEmbedUrl(url) {
    // Handle different YouTube URL formats
    let videoId = "";

    if (url.includes("youtu.be/")) {
      // Short URL format: https://youtu.be/VIDEO_ID
      videoId = url.split("youtu.be/")[1];
    } else if (url.includes("youtube.com/watch?v=")) {
      // Standard URL format: https://www.youtube.com/watch?v=VIDEO_ID
      videoId = url.split("v=")[1];
      // Remove any additional parameters
      if (videoId.includes("&")) {
        videoId = videoId.split("&")[0];
      }
    } else if (url.includes("youtube.com/embed/")) {
      // Already embed format
      return url;
    }

    if (videoId) {
      return `https://www.youtube.com/embed/${videoId}`;
    }

    // Return original URL if we can't parse it
    return url;
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  console.log("ImageWithTextVideoPopup: DOM ready, initializing...");
  new ImageWithTextVideoPopup();
});

// Also initialize for dynamic content (Shopify sections)
document.addEventListener("shopify:section:load", () => {
  console.log("ImageWithTextVideoPopup: Section loaded, initializing...");
  new ImageWithTextVideoPopup();
});
